import builderPathInit from '../../util/builder-path-init';

const { BuilderPage, getServerSideProps } = builderPathInit({
    model: 'learn-page',
    pathPrefix: 'learn',
});
export default BuilderPage;
export { getServerSideProps };